/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Already_StreamingInputs */



/**
* | output |
* | --- |
* | "A response is already being generated. Please wait or stop it first." |
*
* @param {Chat_Already_StreamingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_already_streaming = /** @type {((inputs?: Chat_Already_StreamingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Already_StreamingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Es wird bereits eine Antwort generiert. Bitte warten oder zuerst stoppen.")
	return /** @type {LocalizedString} */ ("A response is already being generated. Please wait or stop it first.")
});